import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toThunkRejectValue } from "../../../../Common/isRequestCanceled";
import {
  BASE_URL,
  UPDATE_DISCOUNT_RUN_TIME_DATA,
  DISCOUNT_CHART_NEW,
  REPORTS_BASE_URL,
  IS_PY_GRAPHS,
  REPORTS_DISCOUNT_AMOUNT,
} from "../../../../Constants/Config";
import { useAuthDetails } from "../../../../Common/cookiesHelper";

const initialState = {
  loading: true,
  discountData: [],
  totalDiscount: 0,
  previousWeekDiscountAmount: 0,
  error: "",
  isCancel: false,
};
let controller = null;

export const getDiscount = createAsyncThunk(
  "discountChart/getDiscount",
  // async (data, { rejectWithValue }) => {
  async (data, { rejectWithValue }) => {
    // return []; // set cors error for tetsing as this call is no more in backend
    const { userTypeData } = useAuthDetails();
    if (controller) {
      controller.abort();
    }

    // Create a new AbortController instance for the current request
    controller = new AbortController();
    try {
      const { token, ...otherUserData } = userTypeData;

      const requestData = { ...(data || {}) };
      const activeType =
        requestData?.activeType || requestData?.view_by || requestData?.date_type;
      const isWeek = String(activeType || "").toLowerCase() === "week";

      const dateInYYYYMMDD = (date) => {
        const year = date?.getFullYear();
        const month = String(date?.getMonth() + 1)?.padStart(2, "0");
        const day = String(date?.getDate())?.padStart(2, "0");
        return `${year}-${month}-${day}`;
      };
      const parseLocalYMD = (ymd) => {
        const parts = String(ymd || "").split("-");
        if (parts.length !== 3) return null;
        const y = Number(parts[0]);
        const m = Number(parts[1]);
        const d = Number(parts[2]);
        if (!y || !m || !d) return null;
        return new Date(y, m - 1, d);
      };

      const getLocalTodayYMD = () => {
        const now = new Date();
        return dateInYYYYMMDD(
          new Date(now.getFullYear(), now.getMonth(), now.getDate())
        );
      };

      const getWeekStartMonday = (date) => {
        const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const day = d.getDay(); // 0=Sun
        const diff = day === 0 ? -6 : 1 - day;
        d.setDate(d.getDate() + diff);
        d.setHours(0, 0, 0, 0);
        return d;
      };

      // ===== WEEK LOGIC =====
      if (isWeek) {
        const shouldUseToday = requestData?.isViewingCurrentPeriod === true;
        const anchorYMD = shouldUseToday
          ? getLocalTodayYMD()
          : (requestData?.end_date || requestData?.start_date);
        const anchorDate = parseLocalYMD(anchorYMD) || new Date();

        const weekStart = getWeekStartMonday(anchorDate);
        const weekEnd = new Date(weekStart);
        weekEnd.setDate(weekEnd.getDate() + 6);

        const result = [];
        for (let i = 0; i < 7; i++) {
          const d = new Date(weekStart);
          d.setDate(d.getDate() + i);
          const formatted = dateInYYYYMMDD(d);
          result.push(`${formatted}_${formatted}`);
        }

        if (shouldUseToday) {
          requestData.start_date = dateInYYYYMMDD(weekStart);
          requestData.end_date = dateInYYYYMMDD(weekEnd);
        } else {
          requestData.start_date = dateInYYYYMMDD(weekStart);
          requestData.end_date = dateInYYYYMMDD(weekEnd);
        }

        requestData.date_range = result.join(",");
        delete requestData.new_date_range;
      }

      // const endpoint = isRuntime
      //   ? UPDATE_DISCOUNT_RUN_TIME_DATA
      //   : DISCOUNT_CHART_NEW;
      const endpoint = DISCOUNT_CHART_NEW;
      const apiUrl =
        IS_PY_GRAPHS === true || IS_PY_GRAPHS === "true"
          ? REPORTS_BASE_URL + REPORTS_DISCOUNT_AMOUNT
          : BASE_URL + endpoint;
      const response = await axios.post(
        // BASE_URL + DISCOUNT_CHART,
        apiUrl,
        { ...requestData, ...otherUserData },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
          signal: controller.signal,
        }
      );


      let total_discount_data = 0;

      if (isWeek) {
        const resultArray = response?.data?.filter_discount_data || [];
        console.log("resultArray", resultArray);
        let total = 0;
        if (Array.isArray(resultArray)) {
          resultArray.forEach((row) => {
            total += +row?.total_discount || 0;
          });
        }

        // const filter_revenue_data = dateKeys.map((d) => ({
        //   total_revenue: parseFloat((total || 0).toFixed(2)),
        //   sale_count: 0,
        // }));
        total_discount_data = total;
        console.log("total_discount_data", total_discount_data);
        return {
          ...response?.data,
          sale_count_data: resultArray,
          total_discount_data: total_discount_data,
        };
      }
      total_discount_data =
        response?.data?.total_discount_data ?? response?.data?.filter_discount_data ?? 0;

      return {
        ...response?.data,
        total_discount_data: total_discount_data,
      };

    } catch (error) {
      if (axios.isCancel(error) || error.name === "CanceledError") {
        return rejectWithValue({ isCanceled: true }); // Mark as canceled
      }
      const customError = {
        message: toThunkRejectValue(error).message,
        status: toThunkRejectValue(error).status,
        data: error.response ? error.response.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const discountChartSlice = createSlice({
  name: "discountChart",
  initialState,
  reducers: {
    clearDiscountChart: (state, action) => {
      state.loading = true;
      state.discountData = [];
      state.totalDiscount = 0;
      state.previousWeekDiscountAmount = 0;
      state.error = "";
      state.isCancel = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDiscount.pending, (state) => {
      state.loading = true;
      state.isCancel = false;
    });
    builder.addCase(getDiscount.fulfilled, (state, action) => {
      state.loading = false;
      state.discountData = action.payload?.filter_discount_data || [];
      state.totalDiscount = action.payload?.total_discount_data || 0;
      state.previousWeekDiscountAmount = action.payload?.previous_discount || 0;
      state.error = "";
      state.isCancel = false;
    });
    builder.addCase(getDiscount.rejected, (state, action) => {
      console.log("catch error=...", state, action);
      console.log("catch error for cancel the API");
      state.loading = false;
      state.discountData = [];
      state.totalDiscount = 0;
      state.previousWeekDiscountAmount = 0;
      state.error = action.error.message;
      state.isCancel = action.payload.isCanceled;
    });
  },
});

export const { clearDiscountChart } = discountChartSlice.actions;
export default discountChartSlice.reducer;
